import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import messages from "../../../../../assets/locale/messages";
import { Chip } from "@mui/material";
import { CHIPS_CLASSES } from "../../../../../utils/Constants";

const KeywordsSection = ({ keywords }) => {
  const lang = useSelector((state) => state.locale.lang);
  const {
    products: { productDetails }
  } = messages[lang];

  return (
    <div className="search-keywords-section p-4 faint-grey-border border-radius-10">
      <h6 className="fsize-20 fweight-600 title-color mb-4">
        {productDetails.searchingKeywords}
      </h6>
      <div className="keywords-container">
        {keywords?.map((keyword, i) => (
          <Chip
            key={`keyword-${i}`}
            label={keyword}
            className={`${CHIPS_CLASSES.grey} me-3 mb-2`}
          />
        ))}
      </div>
    </div>
  );
};

export default KeywordsSection;

KeywordsSection.propTypes = {
  keywords: PropTypes.arrayOf(PropTypes.string).isRequired
};
